import _ from 'underscore';

// Define all pilots used in Smart Page over here.
export const PILOTS = {
  isSubscriptionSignupEnabled: 'IsSubscriptionSignupEnabled',
  isUnifiedProductSubscriptionEnabled: 'IsUnifiedProductSubscriptionEnabled',
  isSmartPageBusinessHourSectionEnabled: 'isSmartPageBusinessHourSectionEnabled',
  isSmartPageImageTextSuggestionEnabled: 'IsSmartPageImageTextSuggestionEnabled',
  isSmartPageM365StockImageEnabled: 'IsSmartPageM365StockImageEnabled',
  isSmartPageVideoSectionEnabled: 'isSmartPageVideoSectionEnabled',
  isSmartPageM365StockImageGalleryEnabled: 'isSmartPageM365StockImageGalleryEnabled',
  isSmartPageMapEnabled: 'isSmartPageMapEnabled',
  isSmartPageCustomizedUpdateEnabled: 'IsSmartPageCustomizedUpdateEnabled',
  isSmartPageM365PremiumFeatureEnabled: 'IsSmartPageM365PremiumFeatureEnabled',
  isSmartPageM365BannerEnabled: 'isSmartPageM365BannerEnabled',
  isSmartPageDarkModeEnabled: 'isSmartPageDarkModeEnabled',
  isM365PremiumUser: 'IsM365PremiumUser', // account level pilot
  isSmartPageProfessionalServicesEnabled: 'isSmartPageProfessionalServicesEnabled',
  isSmartPageBookAppointmentEnabled: 'isSmartPageBookAppointmentEnabled',
  isSmartPageTemplateSuggestionEnabled: 'isSmartPageTemplateSuggestionEnabled',
};

// Get pilot value from ServerContext
export const getPilotValue = (serverContext = {}, key) => {
  const cmuiPilotKey = key && key.replace(/^is/, 'Is');
  const ccuiPilotKey = key && key.replace(/^Is/, 'is');
  const uflPilotKey = key && key.replace(/^(is|Is)/, '').replace(/Enabled$/, ''); // ufl stands for Unified Feature Library

  const cmuiPilotValue = _.result(serverContext.Permissions, cmuiPilotKey, false);
  const ccuiPilotValue = _.result(serverContext.CCUIPilots, ccuiPilotKey, false);
  const uflPilotValue = _.result(serverContext.DynamicPermissions, uflPilotKey, false);

  return cmuiPilotValue || ccuiPilotValue || uflPilotValue;
};
